/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { GameModeTagEnumType } from './GameModeTagEnum'
import { UserGameScheduleStatusEnumType } from './UserGameScheduleStatusEnum'
import { RootStoreType } from './index'

/**
 * UserGameScheduleResponseBase
 * auto generated base class for the model UserGameScheduleResponseModel.
 */
export const UserGameScheduleResponseModelBase = ModelBase.named('UserGameScheduleResponse')
  .props({
    __typename: types.optional(types.literal('UserGameScheduleResponse'), 'UserGameScheduleResponse'),
    _id: types.identifier,
    actionTime: types.union(types.undefined, types.number),
    blindTimer: types.union(types.undefined, types.number),
    blinds: types.union(types.undefined, types.null, types.array(types.integer)),
    channelName: types.union(types.undefined, types.null, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    gameKind: types.union(types.undefined, GameModeTagEnumType),
    hasLeftGame: types.union(types.undefined, types.boolean),
    hash: types.union(types.undefined, types.string),
    hostId: types.union(types.undefined, types.frozen()),
    hostName: types.union(types.undefined, types.string),
    isFull: types.union(types.undefined, types.boolean),
    isHost: types.union(types.undefined, types.boolean),
    isLocked: types.union(types.undefined, types.boolean),
    maxPlayersN: types.union(types.undefined, types.number),
    minPlayersN: types.union(types.undefined, types.number),
    name: types.union(types.undefined, types.string),
    nowPlaying: types.union(types.undefined, types.number),
    scheduleTime: types.union(types.undefined, types.frozen()),
    seats: types.union(types.undefined, types.null, types.array(types.integer)),
    startingChips: types.union(types.undefined, types.number),
    status: types.union(types.undefined, UserGameScheduleStatusEnumType),
    updatedAt: types.union(types.undefined, types.frozen()),
    usersToNotify: types.union(types.undefined, types.null, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserGameScheduleResponseModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get actionTime() {
    return this.__attr('actionTime')
  }
  get blindTimer() {
    return this.__attr('blindTimer')
  }
  get blinds() {
    return this.__attr('blinds')
  }
  get channelName() {
    return this.__attr('channelName')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get gameKind() {
    return this.__attr('gameKind')
  }
  get hasLeftGame() {
    return this.__attr('hasLeftGame')
  }
  get hash() {
    return this.__attr('hash')
  }
  get hostId() {
    return this.__attr('hostId')
  }
  get hostName() {
    return this.__attr('hostName')
  }
  get isFull() {
    return this.__attr('isFull')
  }
  get isHost() {
    return this.__attr('isHost')
  }
  get isLocked() {
    return this.__attr('isLocked')
  }
  get maxPlayersN() {
    return this.__attr('maxPlayersN')
  }
  get minPlayersN() {
    return this.__attr('minPlayersN')
  }
  get name() {
    return this.__attr('name')
  }
  get nowPlaying() {
    return this.__attr('nowPlaying')
  }
  get scheduleTime() {
    return this.__attr('scheduleTime')
  }
  get seats() {
    return this.__attr('seats')
  }
  get startingChips() {
    return this.__attr('startingChips')
  }
  get status() {
    return this.__attr('status')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  get usersToNotify() {
    return this.__attr('usersToNotify')
  }
}
export function selectFromUserGameScheduleResponse() {
  return new UserGameScheduleResponseModelSelector()
}

export const userGameScheduleResponseModelPrimitives =
  selectFromUserGameScheduleResponse()._id.actionTime.blindTimer.blinds.channelName.createdAt.gameKind.hasLeftGame.hash
    .hostId.hostName.isFull.isHost.isLocked.maxPlayersN.minPlayersN.name.nowPlaying.scheduleTime.seats.startingChips
    .status.updatedAt.usersToNotify
